<template>
	<div>
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="backUrl">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">往期限时一分</p>
				</div>
			</div>
		</van-sticky>
		<div>
			<!-- 往期一分 -->
			<div class="xiandaiyanqingBox">
				<van-list v-model="loading" :finished="finished" :finished-text="finishedtxt" @load="onLoad">
					<div class="blockBox">
						<div class="blockLeft" v-for="(item,index) in oldList" :key="index">
							<div class="book_Img" @click="jumpBookinfo(item.book_id)">
								<img :src="$api.$BASE_URL_img + item.cover_image" alt="" />
							</div>
							<div class="blockBookInfo">
								<div class="bookName">
									<span v-for="(bookName,nameIndex) in item.name" v-if="nameIndex <= 8">{{bookName}}</span>
									<p><span>{{Math.floor((item.total_words / 10000) * 100) / 100}}万字</span><span class="wanjie" :class="item.state == '连载中' ? 'txtGreen' : ''">{{item.progress_status_name}}</span></p>
								</div>
								<div class="auther" @click="toZz(item.author_id)"><span>{{item.author}}</span></div>
								<!-- <p class="bookType">{{item.original_name}}-{{item.perspective_name}}-{{item.style_name}}-{{item.type_name}}</p> -->
								<p class="bookType">{{item_vip.original_name != undefined ? item_vip.original_name : '无'}}-{{item_vip.appetency_name != undefined  ? item_vip.appetency_name : '无'}}-{{item_vip.epoch_name != undefined  ? item_vip.epoch_name : '无'}}-{{item_vip.type_name != undefined  ? item_vip.type_name : '无'}}</p>
								<div class="introduction">
									<p>{{item.introduce}}</p>
								</div>
								<div class="book_button">
									<button v-for="i in item.lable_list">{{i.name}}</button>
								</div>
							</div>
						</div>
						<div v-if="oldList.length == 0 ? true : false" style="text-align: center;margin-top: 100px;">
							<img src="../../assets/img/data_null.png" width="100" alt="">
						</div>
					</div>
				</van-list>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {
		components: {},
		data() {
			return {
				title: '',
				active: 0,
				bookInfoList: [],
				oldList: [],
				page: 1,
				limit: 10,
				loading: false,
				finished: false,
				refreshing: false,
				allTotal: 0,
				finishedtxt: '没有更多了',
				onFooter: 0,
				onPullDown: true, //下拉加载
				listlength: 1,
			}
		},
		created() {
			// this.init();
			this.get_old_one_cent()
		},
		mounted() {
			// window.addEventListener('scroll', this.scroll, false) // 监听（绑定）滚轮滚动事件
		},
		methods: {
			backUrl() {
				this.$router.push('/bookcity')
			},
			// 跳转详情页
			jumpBookinfo(val) {

				this.$router.push({
					path: '/bookinfo',
					query: {
						id: val
					}
				})
			},
			//作者专栏
			toZz(val) {
				this.$router.push({
					path: '/autherZl',
					query: {
						user_id: val
					}
				})
			},
			onLoad() {
				if (this.oldList.length <= this.allTotal) {
					this.page += 1; //页数+1
					this.get_old_one_cent();
				}
			},
			get_old_one_cent() {
				this.$axios.post(`${this.$api.old_one_cent}?page=${this.page}&limit=${this.limit}`).then(res => {
					if (res.status == 200) {
						this.allTotal = res.data.data.count;
						this.oldList = this.oldList.concat(res.data.data.list);
						if(res.data.data.count == 0){
							this.finishedtxt = '暂无数据';
						}
						if (res.data.data.count == 0 || res.data.data.list.length == 0 || res.data.data.list.length <= 10) { //数据全部加载完成
							this.finished = true;
						} else {
							this.finished = false;
						}
					} else {
						Toast(res.data.msg);
					}

				})
			},
			// 滚动加载分页
			scroll() {
				var that = this
				// scrollTop 滚动条滚动时，距离顶部的距离
				var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				// windowHeight 可视区的高度
				var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				// scrollHeight 滚动条的总高度
				var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
				// 滚动条到底部的条件
				if (scrollTop + windowHeight == scrollHeight && that.onPullDown == true) {
					// 加载数据 
					that.page = that.page + 1
					that.get_old_one_cent();
				}
			},
		},
		// destroyed () {
		//   window.removeEventListener('scroll', this.scroll) //  离开页面清除（移除）滚轮滚动事件
		// }
	}
</script>


<style>
	.van-tabs__line {
		background-color: transparent;
	}

	.van-tab--active {
		color: #ff4081;
		transform: scale(1.1);
		font-weight: 600;
	}
</style>
<style lang="less" scoped>
	// 头部
	.headerBox {
		height: 160px;
		// background-color: #ff4081;
		display: flex;
		background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
		background-size: 100%;
		border-bottom: 1px solid #f0f0f0;

		/*no*/
		.headerQuery {
			margin-top: 70px;
			padding: 0 16px;
			position: relative;
			display: flex;
			width: 100%;
			height: 90px;
			line-height: 90px;
			color: #000;


			.arrImg {
				img {
					width: 40px;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 0px;
				}
			}

			.header_titile {
				flex: 1;
				text-align: center;
				font-size: 34px;
				/*px*/
			}
		}

	}

	.xiandaiyanqingBox {

		//列表数据
		.blockBox {
			overflow: hidden;
			position: relative;
			background-color: #fff;
			padding: 0px 16px;

			.blockLeft {
				display: flex;
				background-color: #fff;
				padding: 20px 0px;
				padding-bottom: 20px;
				border-bottom: 1px solid #f0f0f0;

				/*no*/
				.book_Img {
					// width: 138px;
					height: 240px;

					img {
						height: 240px;
						display: block;
						float: left;
						-webkit-box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);
						/*no*/
						-moz-box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);
						/*no*/
						box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);
						/*no*/
					}
				}

				.blockBookInfo {
					margin-left: 20px;
					flex: 1;
					font-size: 26px;
					/*px*/
					line-height: 30px;

					.auther {
						color: #000;
						font-size: 26px;
						/*px*/
						opacity: 0.6;
					}

					.bookName {
						// line-height: 40px;
						padding-bottom: 20px;
						font-size: 30px;
						/*px*/
						color: #000000;

						p {
							display: inline-block;
							float: right;
							font-weight: 400;

							span {
								margin-left: 8px;
								color: #4c4c4c;
								font-size: 26px;
								/*px*/
							}

							// .wanjie {
							// 	color: #ff0000;
							// }

							// .txtGreen {
							// 	color: #5ca615;
							// }
						}
					}

					.bookType,
					.introduction {
						padding-top: 20px;
						color: #000;
						font-size: 24px;
						/*px*/
						opacity: 0.6;
					}

					.introduction {
						width: 60vw;
						padding-top: 15px;

						p {
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
						}
					}

					.book_button {
						margin-top: 15px;
						align-items: center;

						button {
							border: 0;
							outline: none;
							border: 1px solid #fec6d5;
							/*no*/
							border-radius: 28px;
							padding: 0px 20px;
							display: inline-block;
							line-height: 36px;
							/*px*/
							background-color: #fff8fa;
							color: #fa7298;
							margin-right: 20px;
							font-size: 24px;
							/*px*/
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							margin-bottom: 10px;
						}

						.active {
							background-color: #fa7298;
							color: #ffffff;
						}
					}
				}
			}

		}
	}
</style>
